
export default {
	props: {
		info: {
			type: Object,
			require: true,
			default: {}
		}
	}
}
